import ContainerCustom from "../../../Components/ContainerCustom";
import Table from "../../../Components/Table/Table";
import TableButton from "../../../Components/Buttons/TableButton";
import StatusColorful from "../../../Components/Table/Components/StatusColorful";
import { useState } from "react";

export default function LogsList() {

  return (
    <>
      <ContainerCustom
        header="لیست لاگ سامانه"
        headSVG="archive"
        colorfulFilter={false}
      >
      <Table
        showEmptyState
          columns={[
            { key: "first", label: "تمامی ستون‌های لاگ سامانه" },
          ]}
          data={[
            {
              first: "تمامی مقادیر لاگ سامانه",
            },
          ]}
        />
      </ContainerCustom>
    </>
  );
}
